import { createFileRoute } from "@tanstack/react-router";
import { routeMeta } from "@/lib/route-meta";
import PublicForms from "@/pages/PublicForms";

export const Route = createFileRoute("/forms")({ head: () => routeMeta('Property Forms | MNRE', 'Submit property and client information securely to MNRE.', '/forms'), component: PublicForms });
